import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../services/AuthContext";
import { getStoredLanguage } from "../services/language";
import { GUEST_LINK_KINDS, buildGuestLinkTarget } from "../utils/guestLinkAccess";
import "./GuestRegisterPrompt.css";

const COPY = {
  es: {
    title: "¡Buena partida!",
    body: "Para seguir jugando en XIMA crea tu cuenta gratis. Lo que jugaste como invitado se guarda en tu cuenta.",
    register: "Crear mi cuenta",
    backPuzzle: "Volver al puzzle",
    backRoom: "Volver a la sala",
    haveAccount: "Ya tengo cuenta",
  },
  en: {
    title: "Good game!",
    body: "Create your free account to keep playing XIMA. What you played as a guest is saved to your account.",
    register: "Create my account",
    backPuzzle: "Back to the puzzle",
    backRoom: "Back to the room",
    haveAccount: "I already have an account",
  },
  ru: {
    title: "Отличная игра!",
    body: "Создайте бесплатный аккаунт, чтобы продолжить играть в XIMA. Всё, что вы сыграли как гость, сохранится в вашем аккаунте.",
    register: "Создать аккаунт",
    backPuzzle: "Вернуться к головоломке",
    backRoom: "Вернуться в комнату",
    haveAccount: "У меня уже есть аккаунт",
  },
  de: {
    title: "Gutes Spiel!",
    body: "Erstelle dein kostenloses Konto, um weiter XIMA zu spielen. Was du als Gast gespielt hast, wird in deinem Konto gespeichert.",
    register: "Mein Konto erstellen",
    backPuzzle: "Zurück zum Puzzle",
    backRoom: "Zurück zum Raum",
    haveAccount: "Ich habe bereits ein Konto",
  },
};

// Shown when a guest who entered through a shared link leaves that puzzle or match.
const GuestRegisterPrompt = ({ pass }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [leaving, setLeaving] = useState(false);
  const language = String(getStoredLanguage() || "es").slice(0, 2).toLowerCase();
  const copy = COPY[language] || COPY.en;
  const backLabel = pass?.kind === GUEST_LINK_KINDS.puzzle ? copy.backPuzzle : copy.backRoom;

  return (
    <main className="xima-guest-register-prompt" role="dialog" aria-modal="true">
      <div className="xima-guest-register-prompt-card">
        <img src="/mejor-logo-336.png" alt="XIMA" />
        <h1>{copy.title}</h1>
        <p>{copy.body}</p>
        <div className="xima-guest-register-prompt-actions">
          <button type="button" className="is-primary" onClick={() => navigate("/register")}>
            {copy.register}
          </button>
          <button
            type="button"
            onClick={() => navigate(buildGuestLinkTarget(pass), { replace: true })}
          >
            {backLabel}
          </button>
          <button
            type="button"
            className="is-link"
            disabled={leaving}
            onClick={async () => {
              setLeaving(true);
              await logout();
            }}
          >
            {copy.haveAccount}
          </button>
        </div>
      </div>
    </main>
  );
};

export default GuestRegisterPrompt;
